import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { UserService } from '../../shared/services/user.service';
import { User } from '../../shared/models/user';
import { combineLatest, Subscription } from 'rxjs';
import { ConnexionInformationsValidatorService } from '../../shared/services/connexion-informations-validator.service';

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
	public show: boolean = false;
	public newUser = false;
	public error?: string;
	public isError: boolean = false;
	public isSuccess: boolean = false;
	public isExpired: boolean = false;
	public successMessage: string;
	public newpassword: string;
	public passwordError: string = '';
	public confirmpassword: string;
	public iconChek = 'check-circle';
	public isButtonDisabled = false;
	public user: Partial<User> = {
		_id: null,
		username: null,
		email: null,
		firstName: null,
		lastName: null,
		phoneNumber: null,
		roles: [],
		password: null,
		oldPassword: null,
		uniqueString: null,
		imageUrl: null,
		city: null
	};
	messageResponse: {
		type?: string;
		message?: string;
	} = {};
	private subscriptions: Subscription[] = [];

	constructor(
		private userService: UserService,
		private activatedRoute: ActivatedRoute,
		public router: Router,
		private connexionInformationsValidatorService: ConnexionInformationsValidatorService,
		private cdr: ChangeDetectorRef,
		private authService: AuthService
	) {}

	async ngOnInit() {
		const res = this.getRouteParams();
	}

	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	private getRouteParams = () => {
		this.isError = false;
		this.isSuccess = false;
		const sub = combineLatest([this.activatedRoute.params, this.activatedRoute.queryParams]).subscribe(
			async res => {
				this.user._id = res[1]?.userId;
				const data = {
					userId: res[1]?.userId,
					token: res[1]?.token
				};

				this.userService.passwordVerification(data).subscribe(res => {
					if (res?.done) {
						this.isSuccess = true;
						this.isError = false;
						this.successMessage = res.message;
					} else {
						this.isSuccess = false;
						this.isError = true;
						this.error = res.message;
						this.isExpired = res.expired;
					}
				});
			}
		);
		this.subscriptions.push(sub);
	};

	Submit() {
		this.cdr.detectChanges();
		this.isButtonDisabled = false;
		if (this.newpassword.length) {
			if (this.passwordError) {
				this.messageResponse.type = 'danger';
				this.messageResponse.message = this.passwordError;
				return;
			}
			if (this.newpassword == this.confirmpassword) {
				const data = {
					userId: this.user._id,
					newPassword: this.newpassword
				};
				this.isButtonDisabled = true;
				this.userService.updatePassword(data).subscribe(
					res => {
						if (res.done) {
							this.messageResponse.type = 'success';
							this.messageResponse.message = res.message;
							setTimeout(() => {
								this.router.navigate(['auth/login']);
							}, 3000);
						} else {
							this.messageResponse.type = 'danger';
							this.messageResponse.message = res.message;
						}
						this.cdr.detectChanges();
					},
					error => {
						this.messageResponse.type = 'danger';
						this.messageResponse.message = error;
					}
				);
			} else {
				this.messageResponse.type = 'danger';
				this.messageResponse.message = 'Error ';
			}
		}
	}
	validatePassword() {
		this.passwordError = this.connexionInformationsValidatorService.validatePasswordComplexity(this.newpassword);
		if (!this.passwordError) {
			this.messageResponse.message = '';
		}
	}
	showPassword() {
		this.show = !this.show;
	}
}
